import React from "react"
import Clamp from "components/clamp"
import Hero from "components/hero"
import News from "components/news"

export default () => {
  return (
    <>
      <Hero>Couchbase to be Acquired for $1.5 billion</Hero>
      <Clamp inset>
        <h1>In the news</h1>
        <News />
      </Clamp>
    </>
  )
}
